var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notfound"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Woops, Looks like this page doesn't exist.")]),_c('v-btn',{attrs:{"outline":"","color":"primary","to":"/home"}},[_vm._v("back to home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }